"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SuggestionKind = void 0;

/* Ported from https://outlookweb.visualstudio.com/Outlook%20Web */
var SuggestionKind;
exports.SuggestionKind = SuggestionKind;

(function (SuggestionKind) {
  SuggestionKind[SuggestionKind["keywords"] = 0] = "keywords";
  SuggestionKind[SuggestionKind["persona"] = 1] = "persona";
})(SuggestionKind || (exports.SuggestionKind = SuggestionKind = {}));